/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum MtServiceProvider {
    SMART_MATE = 'SmartMate',
    INTENTO = 'Intento',
    AZURE = 'Azure',
}
